export default {
  'personal-center.noPhone': '未绑定手机号',
  'personal-center.noDept': '暂无部门',
  'personal-center.prevLoginRegion': '上次登录地点',
  'personal-center.prevLoginTime': '上次登录时间',
  'personal-center.username': '登录名',
  'personal-center.email': '邮箱',
  'personal-center.createTime': '账号创建时间',
  'personal-center.tab1.title': '用户信息',
  'personal-center.tab1.nickname': '姓名',
  'personal-center.tab1.nickname.placeholder': '请输入姓名，长度在 2 到 10 个字符',
  'personal-center.tab1.nickname.required': '请输入姓名',
  'personal-center.tab1.nickname.pattern': '长度在 2 到 10 个字符',
  'personal-center.tab1.mobile': '手机号',
  'personal-center.tab1.mobile.placeholder': '请输入手机号，11 位数字',
  'personal-center.tab1.mobile.required': '请输入手机号',
  'personal-center.tab1.mobile.pattern': '请输入正确的手机号',
  'personal-center.tab1.email': '邮箱',
  'personal-center.tab1.email.placeholder': '请输入邮箱',
  'personal-center.tab1.email.required': '请输入邮箱',
  'personal-center.tab1.email.pattern': '请输入正确的邮箱',
  'personal-center.tab1.sex': '性别',
  'personal-center.tab1.sex.man': '男',
  'personal-center.tab1.sex.woman': '女',
  'personal-center.tab1.sex.required': '请选择性别',
  'personal-center.tab2.title': '修改密码',
  'personal-center.tab2.oldPassword': '旧密码',
  'personal-center.tab2.oldPassword.required': '请输入旧密码',
  'personal-center.tab2.newPassword': '新密码',
  'personal-center.tab2.newPasswordStrength': '强度',
  'personal-center.tab2.newPassword.required': '请输入新密码',
  'personal-center.tab2.confirmPassword': '确认密码',
  'personal-center.tab2.confirmPassword.required': '请再次输入新密码',
  'personal-center.tab2.password.placeholder': '请输入密码，长度在 6 ～ 30 个字符',
  'personal-center.tab2.password.pattern': '长度在 6 ～ 30 个字符',
  'personal-center.tab2.password.same': '新密码不能和旧密码相同',
  'personal-center.tab2.password.different': '新密码和确认密码不一致',
  'personal-center.tab2.confirm': '确认修改密码吗?',
  'personal-center.tab2.success': '密码修改成功，请重新登录',
  // update avatar
  'personal-center.UpdateAvatar.title': '修改头像',
  'personal-center.UpdateAvatar.trigger': '选 择',
  'personal-center.UpdateAvatar.format': '文件格式错误，请上传图片类型,如：JPG，PNG后缀的文件。',
  'personal-center.UpdateAvatar.success': '头像修改成功',
}
